import { useEffect, useState } from "react";
import { photoURL } from "@/data/plates";

/**
 * Foto guardada no Cloud Storage.
 *
 * O caminho é o que fica no documento; a URL assinada é resolvida aqui e
 * fica em cache. Enquanto ela não chega, o espaço já é reservado com a
 * proporção certa — imagem que aparece empurrando o texto é a forma mais
 * fácil de fazer um feed parecer quebrado.
 */
export function StoragePhoto(
  { path, alt = "", className, ratio = "1 / 1" }:
  { path: string | null | undefined; alt?: string; className?: string; ratio?: string },
) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let vivo = true;
    setUrl(null);
    photoURL(path).then((u) => { if (vivo) setUrl(u); });
    return () => { vivo = false; };
  }, [path]);

  return (
    <div className={`foto ${className ?? ""}`} style={{ aspectRatio: ratio }}>
      {url ? <img src={url} alt={alt} loading="lazy" /> : <span className="foto-vazia" aria-hidden="true">🍽️</span>}
    </div>
  );
}
